import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';
import { NODE_HEIGHT, NODE_WIDTH } from '../../../../../utils/dimensions';

export const DropTargetContainer = styled.div`
  background: ${colors.buttonPrimaryDisabled};
  outline: 2px dashed ${colors.buttonPrimary};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.16);
  display: flex;
  width: ${NODE_WIDTH}px;
  height: ${NODE_HEIGHT}px;
  line-height: ${NODE_HEIGHT}px;
  align-items: center;
  justify-content: center;
  padding-right: ${sizes.xSmall}px;
  text-align: center;
`;
